<span class="p-float-label">
  <p-calendar [(ngModel)]="calendarValue" [selectionMode]="mode ? mode : 'single'" [readonlyInput]="true"
              [showTime]="time" [showSeconds]="seconds" (onSelect)="onInput($event)"
              [appendTo]="appendTo ? appendTo : ''" [disabled]="formControl['disabled']"
              [minDate]="minDate" [maxDate]="maxDate"></p-calendar>
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+field) | translate"></label>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                        [required]="formControl.errors?.['required']"
                        [holidaysRange]="formControl.errors?.['holidaysRange']"
                        ></app-form-input-error>
</span>
